import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm, useFormContext } from "react-hook-form";

export const CashDiscountItem: React.FC<any> = React.memo((props) => {
  const {
    register,
    control,
    setValue
  } = useFormContext();

  const handlePercentageButtonClick = (value: string) => {
    setValue("discountpercentage", value); // Update the "discountpercentage" field
    setValue("discountamount", "0"); // Reset the "discountamount" field to zero  };
  }
  const handleAmountButtonClick = (value: string) => {
    setValue("discountamount", value); // Update the "discountamount" field
    setValue("discountpercentage", "0"); // Reset the "discountpercentage" field to zero  };
  }
  return (
   
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography>Discount Percentage</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSTextField
          label={""}
          {...register("discountpercentage")}
          id="discountpercentage"
          name="discountpercentage"
          control={control}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography>Discount Amount</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSTextField
          label={""}
          {...register("discountamount")}
          id="discountamount"
          name="discountamount"
          control={control}
          rules={{ required: false }}
        />

<Grid item container spacing={2} sx={{ mt: 2 }} >
       
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      },}} onClick={() => handlePercentageButtonClick("5")}>
           5%
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      },}} onClick={() => handlePercentageButtonClick("10")}>
           10%
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      },}} onClick={() => handlePercentageButtonClick("15")}>
            15%
          </Button>
        </Grid>

       
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      }}} onClick={() => handleAmountButtonClick("50")}>
            50%
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      }}} onClick={() => handleAmountButtonClick("100")}>
            100%
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="outlined" fullWidth sx={{height:"6rem",width:"8rem",color:"black",borderColor:"green",'&:hover': {
        backgroundColor: "green", 
        color: "white",  
        borderColor: "green",  
      }}} onClick={() => handleAmountButtonClick("150")}>
            150%
          </Button>
        </Grid>
      </Grid>
      </Grid>

   
     
    </Grid>
  );
});
